import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ResultOptionModel } from '../../models/result-option.model';

@Component({
  selector: 'hazmatsuite-next-result-options',
  templateUrl: './result-options.component.html',
  styleUrls: ['./result-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultOptionsComponent {
  @Input() title = '';
  @Input() items: ResultOptionModel[] = [];
}
